import React, { useState } from 'react';
import type { PhoneNumberElement } from 'models/forms/formElements/PhoneNumberElement';

type Props = {
  element: PhoneNumberElement;
  isEditing: boolean;
  onUpdate: (updatedElement: PhoneNumberElement) => void;
  isDisabled?: boolean;
};

const PhoneNumberElementComponent: React.FC<Props> = ({ element, isEditing, onUpdate, isDisabled }) => {
  const [name, setName] = useState(element.name);
  const [placeholder, setPlaceholder] = useState(element.placeholder || '');

  if (isEditing) {
    return (
      <div className="space-y-3">
        <div>
          <p className="mb-1 text-sm text-gray-700">Label</p>
          <input
            type="text"
            value={name}
            onChange={(e) => {
              const next = e.target.value;
              setName(next);
              onUpdate({ ...element, name: next });
            }}
            className="block w-full px-3 py-2 border border-gray-300 rounded"
          />
        </div>

        <div>
          <p className="mb-1 text-sm text-gray-700">Placeholder</p>
          <input
            type="text"
            value={placeholder}
            onChange={(e) => {
              const next = e.target.value;
              setPlaceholder(next);
              onUpdate({ ...element, placeholder: next });
            }}
            className="block w-full px-3 py-2 border border-gray-300 rounded"
          />
        </div>
      </div>
    );
  }

  return (
    <div className="mb-2.5">
      <label htmlFor={element.id} className="block mb-1.5 font-medium text-gray-700">
        {element.name}{element.isRequired ? ' *' : ''}
      </label>
      <input
        type="tel"
        id={element.id}
        placeholder={element.placeholder || ''}
        value={element.value || ''}
        onChange={(e) => onUpdate({ ...element, value: e.target.value })}
        className="px-3 py-2 border border-gray-300 rounded"
        disabled={isDisabled ?? false}
      />
    </div>
  );
};

export default PhoneNumberElementComponent;
